export type Service = {
  /** Shown as a directory name, e.g. "web-apps/". */
  name: string;
  copy: string;
};

export const services: readonly Service[] = [
  {
    name: 'web-apps/',
    copy: 'Custom web applications, dashboards and customer portals, responsive and built to scale.',
  },
  {
    name: 'mobile-apps/',
    copy: 'Native and cross-platform iOS and Android apps, from prototype to app store release.',
  },
  {
    name: 'backend-apis/',
    copy: 'APIs, databases and integrations with clean architecture that stays maintainable.',
  },
  {
    name: 'cloud-devops/',
    copy: 'Linux servers, CI/CD pipelines, containers, monitoring and hosting you can rely on.',
  },
  {
    name: 'it-outsourcing/',
    copy: 'Dedicated developers and ongoing support that extend your team, from maintenance to full project delivery.',
  },
];
